import { Badge, Flex, Text, useMantineTheme } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import { InvestmentDocumentCardStyles } from './InvestmentDocumentCard.styles.tsx';
import { InvestmentDocumentCardProps } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/InvestmentDetails/components/InvestmentDetailsContent/components/InvestmentDocumentCard/InvestmentDocumentCard.types.ts';

type Props = InvestmentDocumentCardProps;

export const InvestmentDocumentCard = ({
	documentName,
	subtitle,
	customSubtitle,
	statusText,
	statusColor,
	statusTextColor,
}: Props) => {
	const theme = useMantineTheme();

	return (
		<InvestmentDocumentCardStyles>
			<Flex justify="space-between" align="center" gap="0.5rem">
				<Flex align="center" gap="0.5rem" style={{ flex: 1, minWidth: 0 }}>
					<div className="icon-wrapper">
						<Icon
							variant="document-v3-rounded"
							size="vlg"
							color={theme.colors.gray[9]}
						/>
					</div>

					<div style={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
						<Text fw={600} c="dark.8" title={documentName} className="doc-name">
							{documentName}
						</Text>

						{subtitle && <Text c="dark.0">{subtitle}</Text>}

						{customSubtitle}
					</div>
				</Flex>

				<Flex align="center" gap="0.25rem" style={{ flexShrink: 0 }}>
					<Badge
						variant="outline"
						size="sm"
						mih="1.5rem"
						h="1.5rem"
						radius="999px"
						p="0.25rem 0.5rem"
						color={statusColor}
					>
						<Text fz="sm" fw={400} c={statusTextColor}>
							{statusText}
						</Text>
					</Badge>
				</Flex>
			</Flex>
		</InvestmentDocumentCardStyles>
	);
};
